export default __webpack_public_path__ + "static/media/heart.c1a3b20f.svg";